<template>
  <div class="flex-column-middle-gap position-relative padding-20 bg-grey-04">
    <img :src="this.$logo" alt="COSI" style="width: 200px" />
    <p class="grey-00 text-center">Mon Compagnon de Suivi&nbsp;des&nbsp;Injections</p>
  </div>
</template>
